module.exports = __webpack_public_path__ + "img/mqttDTU2.c41f8fb0.jpg";